import { getEmailSettingsApi, setEmailPrefApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import ToggleButton from 'Components/Element/ToggleButton';

// Single on/off email setting — used by admins, admin assistants and attorney
// assistants. Styled like the 18b email settings page; same APIs as before
// (type 0 = subscribed, type 1 = no email). Pads itself like ProfEmailNotification.
function PlainEmailNotifications() {

    const {userDetails, makeApiCallFunc} = useContext(Context);
    const [emailPref, setEmailPref] = useState(null);
    const [busy, setBusy] = useState(false);
      useEffect(() => {
        makeApiCallFunc(getEmailSettingsApi, null, ({data}) => {
          setEmailPref(data);
        },
        (data) => console.log(data))
      },[userDetails])

    const loaded = emailPref !== null;
    const subscribed = emailPref?.type === 0;

    const stopEmails = () => {
      setBusy(true);
      makeApiCallFunc
      (  setEmailPrefApi, {type: 1,  user: userDetails._id},
        ({data}) =>  {
          setBusy(false);
          toast.success("Emails turned off. You won't receive emails from us.")
          setEmailPref((prev) => ({"type": 1, "triggerType": 1}))
        },
        (data) => { setBusy(false); console.log(data); toast.error('Could not update your email settings. Please try again.'); })
    }
    const startEmails = () => {
      setBusy(true);
      makeApiCallFunc
      (  setEmailPrefApi, {type: 0, user: userDetails._id}, ({data}) => {
        setBusy(false);
        toast.success("Emails turned on. You'll receive updates from us.")
        setEmailPref((prev) => ({"type":0, "triggerType": 0}))
      }
      , (data) => { setBusy(false); console.log(data); toast.error('Could not update your email settings. Please try again.'); })
    }

  return (
    <div className="w-full px-2 lg:pl-4 lg:pr-20">
      <div className='w-full pt-6 lg:pt-8 pl-2 lg:pl-6 pb-10 font-plexsans' style={{ maxWidth: '860px' }}>
        <h2 style={{ margin: '0 0 4px', font: "400 22px/1.25 'Spectral',serif", color: '#14213d' }}>Email notifications</h2>
        <p style={{ margin: '0 0 26px', font: "400 13.5px/1.5 'IBM Plex Sans',sans-serif", color: 'rgba(20,33,61,.55)' }}>
          Choose whether we email you about case activity and your account.
        </p>

        <div
          className='flex items-start justify-between bg-white'
          style={{ gap: '20px', border: '1px solid rgba(20,33,61,.12)', borderRadius: '6px', padding: '18px 20px' }}
        >
          <div>
            <div className='flex items-center flex-wrap' style={{ gap: '10px', marginBottom: '5px' }}>
              <span style={{ fontWeight: 600, fontSize: '14px', color: '#14213d' }}>Email updates</span>
              {loaded &&
                <span style={{
                  font: "600 10px/1 'IBM Plex Mono',monospace", letterSpacing: '.06em', textTransform: 'uppercase',
                  padding: '4px 8px', borderRadius: '4px',
                  color: subscribed ? '#3a7d4f' : 'rgba(20,33,61,.5)',
                  background: subscribed ? 'rgba(58,125,79,.1)' : 'rgba(20,33,61,.06)',
                }}>{subscribed ? 'On' : 'Off'}</span>
              }
            </div>
            <div style={{ fontSize: '12.5px', lineHeight: 1.55, color: 'rgba(20,33,61,.55)', maxWidth: '560px' }}>
              {subscribed
                ? "You're receiving the latest updates on your cases and your account. Turn this off to stop all emails from us."
                : "You're not receiving emails from us. Turn this on to get the latest updates on your cases and your account."}
            </div>
          </div>
          <div style={{ marginTop: '2px' }}>
            <ToggleButton
              toggleOption={subscribed}
              onColor="#3a7d4f"
              disabled={!loaded || busy}
              callbackFunc={subscribed ? stopEmails : startEmails}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlainEmailNotifications
